<template>
  <div>
    <ui-form-item class="mt-5" label="Примечание к ответу">
      <ui-form-text :value="answer_help" @update:modelValue="v=>{set('answer_help', v)}"
                    placeholder="Пример: Ответ должен быть в виде одного слова без кавычек"/>
    </ui-form-item>

    <div class="block font-medium leading-5 text-gray-700 mt-5">Правильные ответы</div>
    <div class="text-gray-500 text-sm mb-5">
      Укажите правильные ответы. При проверке ответа регистр букв учитываться не будет, а пробелы будут удалены. Нажмите
      <code
          class="text-red-500">Enter &#8629;</code>, чтобы добавить еще один вариант.
    </div>

    <ui-form-item v-for="(answer, i) in answers" :key="i" @keydown.enter.prevent.stop="add(i)">
      <ui-form-text :placeholder="'Верный ответ ' + (i + 1)" :value="answer" :ref="setItemRef"
                    :class="[answers.length > 1 ? 'rounded-r-none': '']"
                    @update:modelValue="v=>{set_answer_val(i, v)}"/>
      <template #actions>
        <ui-input-action @click="del(i)" :disabled="answers.length === 1" class="border-l-0 rounded-r-md">
          <x-icon class="h-4 w-4 my-auto text-gray-400"/>
        </ui-input-action>
      </template>
    </ui-form-item>

    <button type="button" class="link text-sm mt-2" @click="add()">
      добавить
    </button>

  </div>
</template>

<script>
import UiInputAction from "@/components/ui/actions/UiInputAction";
import {XIcon} from '@heroicons/vue/solid'
import UiFormItem from "@/components/ui/form/UiFormItem";
import UiFormText from "@/components/ui/form/UiFormText";

export default {
  name: "QuestionText",
  // eslint-disable-next-line vue/no-unused-components
  components: {UiFormText, UiFormItem, UiInputAction, XIcon},
  props: {
    index: {type: Number, required: true}
  },
  data() {
    return {
      itemRefs: [],
    }
  },
  computed: {
    answer_help() {
      return this.$store.getters["event/questions/props"](this.index)['answer_help']
    },
    answers() {
      return this.$store.getters["event/questions/props"](this.index)['answers']
    },
  },
  methods: {
    setItemRef(el) {
      if (el) {
        this.itemRefs.push(el.$el)
      }
    },
    set(key, value) {
      this.$store.dispatch('event/questions/set_prop_key', {
        index: this.index, key, value
      })
    },
    set_answer_val(i, v) {
      let items = this.answers.slice(0)
      items[i] = v
      this.set('answers', items)
    },

    add(n = null) {
      let items = this.answers.slice(0)

      if (n === null)
        n = items.length - 1;

      items.splice(n + 1, 0, '')
      this.set('answers', items)
      setTimeout(() => this.itemRefs[n+1].focus(), 20);
    },
    del(n) {
      let items = this.answers.slice(0)
      items.splice(n, 1)
      this.set('answers', items)
    },
  },
  beforeUpdate() {
    this.itemRefs = []
  },
  beforeMount() {

    if (!(Array.isArray(this.answers)))
      this.set('answers', [''])

    if (!this.answer_help)
      this.set('answer_help', '')

  }

}
</script>

